import { logEvent } from './logGaEvent'

export const logRecommendedFilters = ({ filterName = '' }) => {
  logEvent('filter', {
    filter_type: 'recommended',
    filter_name:
      filterName /*filter name, such as stops, price, vehical_type, or chip if the type is dynamic*/,
    product_name: 'air' /*values: air, car, hotel, bundle,null -if not tied to any specific products*/,
    page_name:
      'listings' /*examples: details, checkout; web uses page_name, app uses screen_name. the value are the same*/,
  })
}
